import { injectable } from 'inversify'
import { Message, Field, Type } from "protobufjs/light"
import { Result, ok } from '@xlearn/common'
import * as SerializationApi from '@/app/state-serialization/api'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure'
import { EmbedState } from './embed-interfaces'

@injectable()
export class EmbedStateProtobufSerializer implements SerializationApi.StateSerializationPlugin<EmbedState> {

  key = { id: 40, name: { ns: 'interaction-suspend-data', name: 'embed' }, format: 'protobuf' }

  serialize(data: EmbedState): Result<Uint8Array, SerializationApi.SerializerError> {
    
    const message = new EmbedStateProtoMessage({
      touched: data.touched
    })

    return ProtobufSerializer.serialize<EmbedStateProtoMessage>(message, EmbedStateProtoMessage)
  }

  deserialize(content: Uint8Array): Result<EmbedState, SerializationApi.DeserializerError> {
    const deserializeResult = ProtobufSerializer.deserialize<EmbedStateProtoMessage>(content, EmbedStateProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }
 
    const message = deserializeResult.value
    const result: EmbedState = {
      touched: message.touched,
    }
    
    return ok(result)
  }
}

@Type.d('EmbedStateProtoMessage')
class EmbedStateProtoMessage extends Message<EmbedStateProtoMessage> {
  @Field.d(1, 'bool', 'optional', false)
  touched: boolean;
}
